export const GET_IS_MOBILE_GRAPHIC_SHOWN = "GET_IS_MOBILE_GRAPHIC_SHOWN";
export const SET_SHOW_MOBILE_GRAPHIC = "SET_SHOW_MOBILE_GRAPHIC";
export const SET_HIDE_MOBILE_GRAPHIC = "SET_HIDE_MOBILE_GRAPHIC";
export const GET_SHOW_ZOOMED_MODAL = "GET_SHOW_ZOOMED_MODAL";
export const TOGGLE_ZOOM_MODAL = "TOGGLE_ZOOM_MODAL";
export const GET_IMAGE_SRC = "GET_IMAGE_SRC";
export const SET_IMAGE_SRC = "SET_IMAGE_SRC";
export const IS_MOBILE = "IS_MOBILE";
export const SET_IS_MOBILE = "SET_IS_MOBILE";
